<div class="filter">
  <mat-form-field class="example-form-field">
  <input *ngIf="data.config.filterType === EFilterType.TEXT" matInput type="text" [(ngModel)]="value" (keydown.enter)="onSubmit()">
  <input *ngIf="data.config.filterType === EFilterType.DATE" matInput type="date" [(ngModel)]="value" (keydown.enter)="onSubmit()">
    <input matInput class="d-none" *ngIf="data.config.filterType === EFilterType.SELECT"/>
    <mat-select [(ngModel)]="value" *ngIf="data.config.options && data.config.filterType === EFilterType.SELECT">
      <mat-option *ngFor="let option of data.config.options()" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-select>

  <button matSuffix mat-icon-button aria-label="Clear" (click)="value=''">
    <mat-icon>close</mat-icon>
  </button>

  </mat-form-field>


  <button mat-button (click)="onSubmit()">
    Ok
  </button>

</div>
